export default __webpack_public_path__ + "static/media/1702.1cb49469.png";